import dateFns from 'date-fns';
import { fiflboxApi } from '@/utils/api';

const PLAN = {
  WHITE: 0,
  GREY: 1,
  BLACK: 2,
  LIGHT_GREY: 3
};

const state = {
  centerAccount: {
    code: '',
    expiration_date: '2099-12-30',
    created: '2099-12-30',
    plan: null,
    name: '',
    address: '',
    latitude: null,
    longitude: null,
    status: '',
    logo: null,
    user: {
      name: '',
      phone_number: '',
      email: '',
      member: null
    },
    approval_members: 0
  }
};

const getters = {
  getIsGreyPlan() {
    return state.centerAccount.plan === PLAN.GREY;
  },
  getIsWhitePlan() {
    return state.centerAccount.plan === PLAN.WHITE;
  },
  getIsLightGreyPlan(state) {
    return state.centerAccount.plan === PLAN.LIGHT_GREY;
  },
  getIsBookingSystem(state) {
    if (state.centerAccount.plan) {
      return (
        state.centerAccount.plan === PLAN.BLACK ||
        state.centerAccount.plan === PLAN.WHITE
      );
    }

    return true;
  },
  getCenterAccount(state) {
    return {
      ...state.centerAccount,
      isDemoCenter: state.centerAccount.status === 'DEMO',
      isFreeCenter: state.centerAccount.status === 'FREE'
    };
  },
  getNoticeBarStatus(state, getters) {
    let center = getters.getCenterAccount;
    let expirationDate = new Date(center.expiration_date);
    let remainDays = dateFns.differenceInCalendarDays(
      expirationDate,
      new Date()
    );
    let isPrePaymentWeek = center.expiration_date != null && remainDays < 8;

    return {
      isDisplayPrePaymentBar: !center.isFreeCenter && isPrePaymentWeek,
      isDisplayDemoCenterBar: center.isDemoCenter,
      isDisplayFreeCenterBar: center.isFreeCenter
    };
  }
};

const actions = {
  async syncCenterAccount({ commit, dispatch }) {
    try {
      let { data: centerAccount } = await fiflboxApi.v2.getProfile();
      if (centerAccount) {
        commit('setCenterAccount', centerAccount);
      }
    } catch (err) {
      dispatch('timeTable/resetTimeTableInfos');
      await this._vm.$tokenStorage.deleteToken();
      location.replace('');
    }
  },
  async updateCenterAccount({ commit }, data) {
    await fiflboxApi.v2.putProfile(data);
  },
  async updateCenterUser({ state, commit }, data) {
    const centerAccountData = _.cloneDeep(state.centerAccount);
    centerAccountData.user = _.cloneDeep(data);

    delete centerAccountData.user.email;

    await fiflboxApi.v2.putProfile(centerAccountData);
  }
};

const mutations = {
  setCenterAccount(state, centerAccount) {
    if (centerAccount) {
      state.centerAccount = {
        ...centerAccount
      };
    } else {
      state.centerAccount = centerAccount;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
